enum TabOption {
  HELP = 'help',
  FLOW_EDITOR = 'flow-editor',
  CODE_EDITOR = 'diff-editor',
  MARKDOWN_EDITOR = 'markdown-editor',
  PLAN = 'plan',
  InlineChat = 'inline-chat'
}

type TabType =
  | TabOption.CODE_EDITOR
  | TabOption.FLOW_EDITOR
  | TabOption.HELP
  | TabOption.PLAN
  | TabOption.MARKDOWN_EDITOR
  | TabOption.InlineChat

const AllTabs = [
  TabOption.FLOW_EDITOR,
  TabOption.CODE_EDITOR,
  TabOption.HELP,
  TabOption.PLAN,
  TabOption.MARKDOWN_EDITOR,
  TabOption.InlineChat
]

export { AllTabs, TabOption, type TabType }
